import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { formatError } from "@/context/AuthContext";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const inp = "w-full border-b border-espresso/20 bg-transparent py-3 focus:outline-none focus:border-espresso transition-colors text-espresso";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 8) { setErr("La password deve avere almeno 8 caratteri."); return; }
    if (pw !== pw2) { setErr("Le due password non coincidono."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Password aggiornata!");
      setTimeout(() => nav("/accedi"), 2000);
    } catch (e2) {
      setErr(formatError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-sm animate-fade-up" data-testid="reset-password-page">
        <span className="kima-overline text-burgundy">KIMA ID</span>
        <h1 className="font-serif text-4xl text-espresso mt-3 mb-8">Nuova password</h1>
        {!token ? (
          <p className="text-sm text-kimaerror" data-testid="reset-no-token">Link non valido. Richiedi un nuovo link di recupero dalla pagina di accesso.</p>
        ) : done ? (
          <p className="text-sm text-espresso/70" data-testid="reset-done">Password aggiornata con successo. Ti stiamo portando alla pagina di accesso…</p>
        ) : (
          <form onSubmit={submit}>
            {err && <div className="bg-kimaerror/10 text-kimaerror text-sm p-3 rounded-sm mb-4" data-testid="reset-error">{err}</div>}
            <div className="space-y-5">
              <input className={inp} type="password" placeholder="Nuova password (min 8 caratteri)" required data-testid="reset-password" value={pw} onChange={(e) => setPw(e.target.value)} />
              <input className={inp} type="password" placeholder="Conferma password" required data-testid="reset-password-confirm" value={pw2} onChange={(e) => setPw2(e.target.value)} />
            </div>
            <button disabled={loading} data-testid="reset-submit" className="w-full bg-espresso text-ivory py-4 rounded-sm hover:bg-burgundy transition-colors mt-8 disabled:opacity-50">{loading ? "Attendere…" : "Salva nuova password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
